module.exports = __webpack_public_path__ + "static/media/ic-quote-empty.d4ebfc43.svg";